// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionStatus,
  InteractionType,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// Sample app imports
import { AuthenResponseDetail } from "../components/AuthenResponseDetail";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";

const AuthenResponse = () => {
  return <AuthenResponseDetail />;
};

export function AuthenProfile() {
  const authRequest = {
    ...loginRequest,
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <AuthenResponse />
    </MsalAuthenticationTemplate>
  );
}
